import {BadgeProps} from "../../badge/Badge";
import {TYPOGRAPHY_COLORS} from "../../typography/Typography.constants";
import {PRICE_IMPACT_RANGES} from "./PriceImpactValue.constants";

function getPriceImpactComponentProps(priceImpact: number): {
  priceLabel: string;
  badgeType: BadgeProps["type"];
  color: ArrayToUnion<typeof TYPOGRAPHY_COLORS>;
} {
  let priceLabel: string;
  let badgeType: BadgeProps["type"];
  let color: ArrayToUnion<typeof TYPOGRAPHY_COLORS>;

  if (
    priceImpact >= PRICE_IMPACT_RANGES.FAIR.MIN &&
    priceImpact < PRICE_IMPACT_RANGES.FAIR.MAX
  ) {
    priceLabel = "Fair price";
    badgeType = "helper-peace";
    color = "helper-peace";
  } else if (
    priceImpact >= PRICE_IMPACT_RANGES.NORMAL.MIN &&
    priceImpact < PRICE_IMPACT_RANGES.NORMAL.MAX
  ) {
    priceLabel = "Normal price";
    badgeType = "helper-neutral";
    color = "helper-neutral";
  } else if (
    priceImpact >= PRICE_IMPACT_RANGES.EXPENSIVE.MIN &&
    priceImpact < PRICE_IMPACT_RANGES.EXPENSIVE.MAX
  ) {
    priceLabel = "Expensive";
    badgeType = "helper-danger";
    color = "helper-danger";
  } else {
    priceLabel = "Out of range";
    badgeType = "helper-danger";
    color = "helper-danger";
  }

  return {
    priceLabel,
    badgeType,
    color
  };
}

export {getPriceImpactComponentProps};
